import type { ReactNode } from "react";

import styles from "./productAccordion.module.scss";

type UIProps = React.PropsWithChildren<{
  title: string;
  open: boolean;
  toggle: () => void;
  titleExtraComponent?: ReactNode;
}>;

const UI = ({
  open,
  toggle,
  children,
  titleExtraComponent,
  title,
}: UIProps) => {
  return (
    <div className={`${styles.accordion}`}>
      <button className={styles.title} onClick={toggle}>
        <div className={`${styles.icon}  ${open ? styles.open : ""}`} />
        <div className={styles.titleText}>
          <p>{title}</p>
          {titleExtraComponent}
        </div>
      </button>
      <div className={`${styles.children} ${open ? styles.open : ""}`}>
        {children}
      </div>
    </div>
  );
};

export default UI;
